import styled from 'vue3-styled-components';

export const SetNameSection = styled.div`
    display: flex;
    align-items: flex-end;
    gap: 16px;
    margin-bottom: 24px;
`;

export const InputWrapper = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SetNameLabel = styled.label`
    font-size: 18px;
    font-weight: 600;
    color: #333;
`;

export const SetNameInput = styled.input`
    width: 50%;
    padding: 12px 16px;
    border: 2px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    transition: all 0.2s ease;
    margin-left: 0;
    
    &:focus {
        border-color: #0f4c5c;
        outline: none;
        box-shadow: 0 0 0 2px rgba(15, 76, 92, 0.1);
    }
    
    &::placeholder {
        color: #aaa;
    }
`;

export const ModernButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 20px;
    height: 42px;
    background-color: #0f4c5c;
    color: white;
    border: none;
    border-radius: 8px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover {
        filter: brightness(110%);
        transform: translateY(-1px);
    }
`;

export const SetContainer = styled.div`
    background: white;
    border-radius: 12px;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 10px;
    height: calc(100vh - 100px); // 모달 전체 높이 설정
    display: flex;
    flex-direction: column;
`;

export const SetTable = styled.div`
    width: 100%;
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    height: calc(100vh - 300px); // 테이블 높이 설정
`;

export const TableHeader = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 15px;
    color: #000;
    background: #fb8b24;
    border-radius: 8px 8px 0 0;
    padding: 12px 0;
    position: sticky;
    top: 0;
    z-index: 2;
    > div:nth-child(1) { margin-left: 15px; text-align: center; }
    > div:nth-child(2) { margin-left: 210px; text-align: center; }
    > div:nth-child(3) { margin-left: 80px; text-align: center; }
    > div:nth-child(4) { margin-left: 85px; text-align: center; }
    > div:nth-child(5) { text-align: center; }
`;

export const TableBody = styled.div`
    overflow-y: auto;
    max-height: calc(100vh - 400px);
    padding-right: 4px;
    padding-bottom: 120px; /* AddRowButtonWrapper 높이 + 여유 공간 (기존 60px에서 증가) */

    &::-webkit-scrollbar {
      width: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: #f1f5f9;
      border-radius: 10px;
      margin: 4px 0;
    }
    
    &::-webkit-scrollbar-thumb {
      background: linear-gradient(135deg, #cbd5e1, #94a3b8);
      border-radius: 10px;
      border: 2px solid #f1f5f9;
      transition: all 0.2s ease;
      
      &:hover {
        background: linear-gradient(135deg, #94a3b8, #64748b);
        transform: scale(1.05);
      }
      
      &:active {
        background: linear-gradient(135deg, #64748b, #475569);
      }
    }
    
    &::-webkit-scrollbar-corner {
      background: #f1f5f9;
    }
    
    &::-webkit-scrollbar-track-piece {
      background: transparent;
    }
`;

export const TableRow = styled.div`
    display: flex;
    align-items: center;
    padding: 8px 0;
    transition: background-color 0.2s;
    border-bottom: 1px solid #f1f5f9;

    &:hover {
        background-color: #f8fafc;
    }

    > *:nth-child(1) { width: 38%; margin: 0 4px; }
    > *:nth-child(2) { width: 35%; margin: 0 4px; } 
    > *:nth-child(3) { width: 7%; margin: 0 4px; }
    > *:nth-child(4) { width: 12%; margin: 0 4px; }
    > *:nth-child(5) { width: 8%; margin: 0 4px; }
`;

export const Select = styled.select`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #f9fafb;
  font-size: 15px;
  &:focus { border-color: #0f4c5c; outline: none; }
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: #f9fafb;
  font-size: 15px;
  &:focus { border-color: #0f4c5c; outline: none; }
`;

export const AddRowButtonWrapper = styled.div`
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 10px 0;
    width: 100%;
    background: white;
    position: sticky;
    bottom: 0;
    z-index: 2;
    border-top: 1px solid #e2e8f0;
    margin-top: auto;
    min-height: 60px; /* 최소 높이 명시 */
`;

export const AddRowButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background-color: ${props => props.isActive ? '#e0f2fe' : '#f8fafc'};
    color: ${props => props.isActive ? '#0369a1' : '#64748b'};
    border: 1px dashed ${props => props.isActive ? '#0369a1' : '#cbd5e1'};
    border-radius: 8px;
    font-weight: 500;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: #e0f2fe;
        color: #0369a1;
        border-color: #0369a1;
    }
`;

export const MultipleAddButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background-color: ${props => props.isActive ? '#e0f2fe' : '#f8fafc'};
    color: ${props => props.isActive ? '#0369a1' : '#64748b'};
    border: 1px dashed ${props => props.isActive ? '#0369a1' : '#cbd5e1'};
    border-radius: 8px;
    font-weight: 500;
    font-size: 15px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background-color: #e0f2fe;
        color: #0369a1;
        border-color: #0369a1;
    }
`;

export const CreateSetButton = styled.button`
  width: 100%;
  padding: 14px 0;
  background: #fb8b24;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  font-weight: 700;
  margin-top: 24px;
  cursor: pointer;
  transition: background 0.2s;
`;

export const DeleteButton = styled.button`
  background: none;
  border: none;
  color: #ef4444;
  cursor: pointer;
  padding: 0;
  margin-left: 8px;
  &:hover { color: #b91c1c; }
`;

export const MainContainer = styled.div`
    display: flex;
    gap: 24px;
    height: 100%;
    overflow: hidden;
`;

export const LeftSection = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
    padding: 10px;
`;

export const RightSection = styled.div`
    flex: 1;
    min-width: 0;
    border-left: 2px solid #f0f0f0;
    padding-left: 10px;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 10px;
`;

export const TitleContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 20px;
    height: 32px;
    padding: 10px;
`;

export const SectionTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #1a1a1a;
    line-height: 32px;
    margin: 0;
`;

export const SetCount = styled.div`
    background: #e7f5ff;
    color: #228be6;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 15px;
    font-weight: 600;
    display: flex;
    align-items: center;
    height: 28px;
    box-shadow: 0 2px 4px rgba(34, 139, 230, 0.1);
`;

export const SetList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
    overflow-y: auto;
    max-height: calc(100vh - 200px);
    padding: 10px;
`;

export const SetCard = styled.div`
    background: white;
    border-radius: 16px;
    padding: 20px;
    transition: all 0.3s ease;
    border: 1px solid #f0f0f0;
    max-width: 100%;
    max-height: 100%;
    position: relative;
    overflow: auto;

    &:hover {
        transform: translateY(-4px);
    }
`;

export const SetCardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #f0f0f0;
`;

export const SetCardTitle = styled.h3`
    font-size: 1.1rem;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
`;

export const SetCardActions = styled.div`
    display: flex;
    gap: 8px;
`;

export const IconButton = styled.button`
    background: transparent;
    border: none;
    padding: 6px;
    cursor: pointer;
    border-radius: 8px;
    color: #64748b;
    transition: all 0.2s ease;

    &:hover {
        background-color: #f1f5f9;
        color: #0f4c5c;
    }
`;

export const DeleteIconButton = styled.button`
    background: transparent;
    border: none;
    padding: 6px;
    cursor: pointer;
    border-radius: 8px;
    color: #64748b;
    transition: all 0.2s ease;

    &:hover {
        background-color: #fee2e2;
        color: #dc2626;
    }
`;

export const SetCardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const SetItemList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const SetItem = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr 1.5fr;
    align-items: center;
    padding: 8px 12px;
    background-color: #f8fafc;
    border-radius: 8px;
    font-size: 0.9rem;
    color: #475569;

    &:hover {
        background-color: #f1f5f9;
    }

    div {
        &:nth-child(2) {
            text-align: center;
        }
        &:nth-child(3) {
            text-align: right;
            color: #0f4c5c;
            font-weight: 500;
        }
    }
`;

export const SetCardTotal = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #f8fafc;
    padding: 5px 20px;
    border-radius: 10px;
    margin: 20px 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

    .total-label {
        font-size: 16px;
        color: #64748b;
        font-weight: 500;
    }

    .total-amount {
        font-size: 18px;
        color: #0f4c5c;
        font-weight: 700;
    }
`;